import React from 'react';

import './CourseDescription.scss';
import sendEvent from '../../helpers/tracking';
import { isExternalLink } from '../../helpers/link';
import icons from '../../shared/assets/icons/redesign';

const { Play } = icons;

export default function CourseDescription({
  imageUrl, title, description, NextLink, showEmailPopup
}) {
  return (
    <div className="courseDescription">
      <div className="courseDescription-video">
        <img
          src={imageUrl}
          alt="course-image"
          className="courseDescription-image"
        />

        <button
          onClick={() => (showEmailPopup(true),
            sendEvent('trackEvent', 'course_lp', 'course_lp_video', 'video'))}
          className="courseDescription-play-button">
          <Play className="courseDescription-play-button-icon" />
        </button>
      </div>

      <h4 className="courseDescription-title">{title}</h4>
      <p className="courseDescription-text">{description}</p>
    </div>
  );
}
